const serializeFillColor = color => {
  if (
    typeof color === "object" &&
    color !== null &&
    color.type &&
    color.stops
  ) {
    return "gradient:" + JSON.stringify(color);
  }
  return color;
};

const formatImageDataForV1 = elementData => {
  if (checkForImageInstructionsBuilderPromise(elementData)) {
    elementData.imageInstructions.forEach(element => {
      delete element.imageElementBuilderPromise;
    });
  }

  if (elementData.fillColors) {
    elementData = {
      ...elementData,
      fillColors: elementData.fillColors.map(fc => ({
        ...fc,
        color: serializeFillColor(fc.color)
      }))
    };
  }

  return elementData;
};

const checkForImageInstructionsBuilderPromise = data => {
  return data.imageInstructions.some(
    instruction => instruction.imageElementBuilderPromise
  );
};

export default formatImageDataForV1;
